import React from "react";
import {
    Grid,
    TextField,
    Typography,
    Card,
    CardContent,
    Stack,
    Box
} from "@mui/material";
import { MyAttachMoneyIcon } from "../../Assets/svg/MyIcons";

const CostInfoStep = ({ formik, organizationDataById }) => {
    return (
        <>
            {/* Form */}
            <Grid container spacing={3}>

                {/* One-Time Setup Fee */}
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        One-Time Platform Setup Fees
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="oneTimeSetupFee"
                        value={formik.values.oneTimeSetupFee}
                        onChange={(e) => {
                            const regex = /^\d*\.?\d{0,2}$/;
                            if (regex.test(e.target.value)) {
                                formik.setFieldValue("oneTimeSetupFee", e.target.value);
                            }
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.oneTimeSetupFee && Boolean(formik.errors.oneTimeSetupFee)}
                        helperText={formik.touched.oneTimeSetupFee && formik.errors.oneTimeSetupFee}
                        inputProps={{
                            inputMode: "numeric",
                            pattern: "[0-9.]*",
                        }}
                    />
                </Grid>

                {/* Ongoing Maintenance */}
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        Ongoing Maintenance & Support
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="ongoingMaintenanceFee"
                        value={formik.values.ongoingMaintenanceFee}
                        onChange={(e) => {
                            const regex = /^\d*\.?\d{0,2}$/;
                            if (regex.test(e.target.value)) {
                                formik.setFieldValue("ongoingMaintenanceFee", e.target.value);
                            }
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.ongoingMaintenanceFee && Boolean(formik.errors.ongoingMaintenanceFee)}
                        helperText={formik.touched.ongoingMaintenanceFee && formik.errors.ongoingMaintenanceFee}
                    />
                </Grid>

                {/* New Merchant Setup */}
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        New Merchant Setup Fee
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="newMerchantSetupFee"
                        value={formik.values.newMerchantSetupFee}
                        onChange={(e) => {
                            const regex = /^\d*\.?\d{0,2}$/;
                            if (regex.test(e.target.value)) {
                                formik.setFieldValue("newMerchantSetupFee", e.target.value);
                            }
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.newMerchantSetupFee && Boolean(formik.errors.newMerchantSetupFee)}
                        helperText={formik.touched.newMerchantSetupFee && formik.errors.newMerchantSetupFee}
                    />
                </Grid>

                {/* Per Merchant Maintenance */}
                <Grid item xs={12} md={6}>
                    <Typography variant="subtitle2" gutterBottom>
                        Ongoing Maintenance & Support per Merchant
                    </Typography>
                    <TextField
                        fullWidth
                        size="small"
                        name="ongoingMaintenancePerMerchantFee"
                        value={formik.values.ongoingMaintenancePerMerchantFee}
                        onChange={(e) => {
                            const regex = /^\d*\.?\d{0,2}$/;
                            if (regex.test(e.target.value)) {
                                formik.setFieldValue("ongoingMaintenancePerMerchantFee", e.target.value);
                            }
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.ongoingMaintenancePerMerchantFee && Boolean(formik.errors.ongoingMaintenancePerMerchantFee)}
                        helperText={formik.touched.ongoingMaintenancePerMerchantFee && formik.errors.ongoingMaintenancePerMerchantFee}
                    />
                </Grid>

            </Grid>
        </>
    );
};

export default CostInfoStep;
